import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 50 }
  }

  submit () {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      const form = this.element.tagName.toLowerCase() !== 'form' ? this.element.closest('form') : this.element
      form.requestSubmit()
    }, this.delayValue)
  }

  disconnect () {
    clearTimeout(this.timeout)
  }
}
